/* rbsv4-main-product — gallery wiring + Seal frequency pill buttons.
   The subscription / one-time choice is handled by the Seal Subscriptions widget
   (an @app block inside the product form); Dawn's <product-form> submits its
   selling_plan natively. This file drives the gallery and replaces Seal's
   frequency <select> with horizontal pill buttons (full-width dropdown fallback). */
(function () {
  'use strict';

  /* Mobile gallery: thumbnail click scrolls the carousel; scroll keeps the active thumb in sync. */
  function initGallery(root) {
    var track = root.querySelector('[data-rbsv4-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rbsv4-thumb-index]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-rbsv4-media-index]'));
    if (!track || !items.length) return;

    function setActive(index) {
      items.forEach(function (it) {
        it.classList.toggle('is-active', it.dataset.rbsv4MediaIndex === String(index));
      });
      thumbs.forEach(function (th) {
        th.classList.toggle('is-active', th.dataset.rbsv4ThumbIndex === String(index));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.rbsv4ThumbIndex, 10);
        var target = items[index];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
        setActive(index);
      });
    });

    if ('IntersectionObserver' in window && thumbs.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              setActive(parseInt(entry.target.dataset.rbsv4MediaIndex, 10));
            }
          });
        },
        { root: track, threshold: [0.6] }
      );
      items.forEach(function (it) { observer.observe(it); });
    }
  }

  /* Replace Seal's frequency <select> with horizontal pill buttons that proxy it.
     A native <select> can't be turned into buttons via CSS, so we drive it with JS.
     If Seal's markup ever changes (no select found), the CSS leaves a full-width
     dropdown as the fallback. */
  function syncFreqActive(wrap, select) {
    Array.prototype.forEach.call(wrap.children, function (b) {
      b.setAttribute('aria-pressed', b.dataset.value === select.value ? 'true' : 'false');
    });
  }

  function buildFreqButtons(slot) {
    var optionsWrap = slot.querySelector('.sls-selling-plan-group-options');
    var select = slot.querySelector('select.sls-select, select[name="subs_interval"]');
    if (!optionsWrap || !select || !select.options.length) {
      slot.classList.remove('rbsv4-has-freq');
      return;
    }

    var existing = optionsWrap.querySelector('.rbsv4-freq');
    // Rebuild only when missing or the option set changed (keeps the MutationObserver idempotent).
    if (existing && existing.children.length === select.options.length) {
      syncFreqActive(existing, select);
      return;
    }
    if (existing) existing.remove();

    // Pill subtitles (easy to change / move to section settings later).
    var POPULAR_LABEL = 'Most Popular';
    var SAVINGS_LABEL = 'Save 10%';

    var wrap = document.createElement('div');
    wrap.className = 'rbsv4-freq';
    Array.prototype.forEach.call(select.options, function (opt, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rbsv4-freq__btn';
      btn.dataset.value = opt.value;
      btn.setAttribute('aria-pressed', opt.value === select.value ? 'true' : 'false');
      var label = opt.textContent.replace(/^\s*deliver every\s*/i, '').trim() || opt.textContent;
      var main = document.createElement('span');
      main.className = 'rbsv4-freq__main';
      main.textContent = label;
      btn.appendChild(main);
      var sub = document.createElement('span');
      sub.className = 'rbsv4-freq__sub';
      if (index === 0) {
        sub.textContent = POPULAR_LABEL;
        sub.classList.add('rbsv4-freq__sub--popular');
      } else {
        sub.textContent = SAVINGS_LABEL;
      }
      btn.appendChild(sub);
      btn.addEventListener('click', function () {
        if (select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncFreqActive(wrap, select);
      });
      wrap.appendChild(btn);
    });
    optionsWrap.appendChild(wrap);
    slot.classList.add('rbsv4-has-freq');

    if (!select.dataset.rbsv4Bound) {
      select.dataset.rbsv4Bound = '1';
      select.addEventListener('change', function () {
        var current = optionsWrap.querySelector('.rbsv4-freq');
        if (current) syncFreqActive(current, select);
      });
    }
  }

  function initSealFreq() {
    document.querySelectorAll('.rbsv4-seal-slot').forEach(function (slot) {
      buildFreqButtons(slot);
      var observer = new MutationObserver(function () { buildFreqButtons(slot); });
      observer.observe(slot, { childList: true, subtree: true });
    });
  }

  /* Lightbox: click any gallery image to view it larger, with prev/next and click-to-zoom. */
  var lightbox = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    var el = document.createElement('div');
    el.className = 'rbsv4-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');
    el.innerHTML =
      '<button type="button" class="rbsv4-lightbox__btn rbsv4-lightbox__close" aria-label="Close">✕</button>' +
      '<button type="button" class="rbsv4-lightbox__btn rbsv4-lightbox__nav rbsv4-lightbox__nav--prev" aria-label="Previous image">‹</button>' +
      '<div class="rbsv4-lightbox__stage"><img class="rbsv4-lightbox__img" alt=""></div>' +
      '<button type="button" class="rbsv4-lightbox__btn rbsv4-lightbox__nav rbsv4-lightbox__nav--next" aria-label="Next image">›</button>';
    document.body.appendChild(el);

    lightbox = { el: el, img: el.querySelector('.rbsv4-lightbox__img'), items: [], index: 0, lastFocus: null };

    el.querySelector('.rbsv4-lightbox__close').addEventListener('click', closeLightbox);
    el.querySelector('.rbsv4-lightbox__nav--prev').addEventListener('click', function () { stepLightbox(-1); });
    el.querySelector('.rbsv4-lightbox__nav--next').addEventListener('click', function () { stepLightbox(1); });
    el.addEventListener('click', function (e) { if (e.target === el) closeLightbox(); });
    lightbox.img.addEventListener('click', function () { el.classList.toggle('is-zoomed'); });
    document.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') stepLightbox(-1);
      else if (e.key === 'ArrowRight') stepLightbox(1);
      else if (e.key === 'Tab') {
        // Minimal focus trap across the modal's buttons.
        var focusables = Array.prototype.slice
          .call(el.querySelectorAll('button'))
          .filter(function (b) { return b.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    return lightbox;
  }

  function showLightboxImage() {
    var item = lightbox.items[lightbox.index];
    if (!item) return;
    lightbox.el.classList.remove('is-zoomed');
    lightbox.img.src = item.getAttribute('data-rbsv4-full');
    lightbox.img.alt = item.getAttribute('data-rbsv4-alt') || '';
    var multi = lightbox.items.length > 1;
    lightbox.el.querySelector('.rbsv4-lightbox__nav--prev').style.display = multi ? '' : 'none';
    lightbox.el.querySelector('.rbsv4-lightbox__nav--next').style.display = multi ? '' : 'none';
  }

  function stepLightbox(dir) {
    var n = lightbox.items.length;
    if (!n) return;
    lightbox.index = (lightbox.index + dir + n) % n;
    showLightboxImage();
  }

  function openLightbox(items, index) {
    ensureLightbox();
    lightbox.items = items;
    lightbox.index = index;
    lightbox.lastFocus = document.activeElement;
    showLightboxImage();
    lightbox.el.classList.add('is-open');
    document.body.classList.add('rbsv4-lightbox-open');
    lightbox.el.querySelector('.rbsv4-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.el.classList.remove('is-open', 'is-zoomed');
    document.body.classList.remove('rbsv4-lightbox-open');
    if (lightbox.lastFocus && lightbox.lastFocus.focus) lightbox.lastFocus.focus();
  }

  function initLightbox(galleryRoot) {
    var items = Array.prototype.slice.call(galleryRoot.querySelectorAll('[data-rbsv4-full]'));
    if (!items.length) return;
    items.forEach(function (item, i) {
      item.addEventListener('click', function () { openLightbox(items, i); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(items, i); }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-rbsv4-gallery]').forEach(function (gallery) {
      initGallery(gallery);
      initLightbox(gallery);
    });
    initSealFreq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
